import request from '../utils/request'

export default {
  // 获取所有字典类型
  findAllDictType(params) {
    return request.get('/api/dict/type', { params })
  },
  
  // 根据ID获取字典类型
  findDictTypeById(id) {
    return request.get(`/api/dict/type/${id}`)
  },
  
  // 添加字典类型
  addDictType(dictType) {
    return request.post('/api/dict/type', dictType)
  },
  
  // 更新字典类型
  updateDictType(id, dictType) {
    return request.put(`/api/dict/type/${id}`, dictType)
  },
  
  // 删除字典类型
  deleteDictType(id) {
    return request.delete(`/api/dict/type/${id}`)
  },
  
  // 批量删除字典类型
  deleteDictTypeBatch(ids) {
    return request.delete('/api/dict/type/batch', { data: ids })
  },

  // 检查字典类型编码是否存在
  checkTypeCode(params) {
    return request.get('/api/dict/type/checkTypeCode', { params })
  },

  // 获取所有字典项
  findAllDictItem(params) {
    return request.get('/api/dict/item', { params })
  },

  // 根据ID获取字典项
  findDictItemById(id) {
    return request.get(`/api/dict/item/${id}`)
  },

  // 添加字典项
  addDictItem(dictItem) {
    return request.post('/api/dict/item', dictItem)
  },

  // 更新字典项
  updateDictItem(id, dictItem) {
    return request.put(`/api/dict/item/${id}`, dictItem)
  },

  // 删除字典项
  deleteDictItem(id) {
    return request.delete(`/api/dict/item/${id}`)
  },

  // 批量删除字典项
  deleteDictItemBatch(ids) {
    return request.delete('/api/dict/item/batch', { data: ids })
  },

  // 根据字典类型编码获取字典项
  findDictItemByDictCode(params) {
    return request.get('/api/dict/item/code', { params })
  },

}